// extracted by mini-css-extract-plugin
export default {"message":"servererror_message__NNysE"};